import { useAuthContext } from '@lp/core/auth';
import { CaseStatus } from '@/api/apis/case';
import { useLogisticsById } from '@/queries/route-planner';
import { useDeviceTrackingByCaseIdQuery } from '@/queries/device-tracking';
import { isAllowedStatus } from '@/utils/helpers';
import { CaseDetailsPermissions } from '@/permissions';

type UseDeviceLocationTrackingProps = {
  caseId: string;
  status: CaseStatus;
  logisticsId?: string;
};

export const useDeviceLocationTracking = ({ caseId, status, logisticsId }: UseDeviceLocationTrackingProps) => {
  const { checkPermission } = useAuthContext();
  const hasReadPermission = checkPermission(CaseDetailsPermissions.LocationTrackingRead);
  const { data: logisticsData } = useLogisticsById(hasReadPermission ? logisticsId : undefined);
  const txEtaEnabled = isAllowedStatus({
    statusFrom: CaseStatus.PendingLogistics,
    statusTo: CaseStatus.Finished,
    currentStatus: status,
  });
  const withLocationTracking = hasReadPermission && !!logisticsData?.isTmdxDriveCompatible && txEtaEnabled;
  const { data: deviceTracking } = useDeviceTrackingByCaseIdQuery(caseId, withLocationTracking);

  return deviceTracking;
};
